// Zotte Zomer Ronse 2026 — Programma seed data
// Used in fase 1 as static seed; in fase 2 this gets replaced by an admin/CMS data source.
// IMPORTANT: NO PRICES, NO FINANCIAL FIGURES allowed in this file.

export const PROGRAM = [
    {
        id: 'kleine-markt-11-07',
        date: '11/7',
        dateLong: '11 juli 2026',
        weekday: 'zaterdag',
        location: 'Kleine Markt',
        time: '18u – 1u',
        accent: 'pink', // pastel roze
        ringClass: 'zz-ring-pink',
        bgClass: 'bg-[var(--pink-soft)]',
        bgVivid: 'bg-[var(--pink)]',
        chipBgClass: 'bg-[var(--pink)]',
        sticker: 'Gratis toegang',
        kidsSticker: null,
        artists: [
            { name: 'Neon Forest', headline: true },
            { name: 'Fixkes', headline: true },
            { name: 'Question', headline: false },
            { name: 'Drezz', headline: false },
        ],
    },
    {
        id: 'stadstuin-25-07',
        date: '25/7',
        dateLong: '25 juli 2026',
        weekday: 'zaterdag',
        location: 'Stadstuin',
        time: '16u – 23u',
        accent: 'mint',
        ringClass: 'zz-ring-mint',
        bgClass: 'bg-[var(--mint-soft)]',
        bgVivid: 'bg-[var(--mint)]',
        chipBgClass: 'bg-[var(--mint)]',
        sticker: 'Gratis toegang',
        kidsSticker: 'Familie · kinderactiviteiten',
        artists: [
            { name: 'Kinderactiviteiten', headline: false, isActivity: true },
            { name: 'Euforia', headline: false },
            { name: 'Astrid Stockman', headline: true },
            { name: 'Belle Perez', headline: true },
            { name: "Remastered2DJ's", headline: false },
            { name: 'Vuurspuwact', headline: false, isActivity: true },
        ],
    },
    {
        id: 'grote-markt-29-08',
        date: '29/8',
        dateLong: '29 augustus 2026',
        weekday: 'zaterdag',
        location: 'Grote Markt',
        time: '16u – 1u',
        accent: 'yellow',
        ringClass: 'zz-ring-yellow',
        bgClass: 'bg-[var(--yellow-soft)]',
        bgVivid: 'bg-[var(--yellow)]',
        chipBgClass: 'bg-[var(--yellow)]',
        sticker: 'Gratis toegang',
        kidsSticker: 'Familie · kinderactiviteiten',
        artists: [
            { name: 'Kinderactiviteiten', headline: false, isActivity: true },
            { name: 'Sanchez Taelmanoz', headline: false },
            { name: 'Elle Fray', headline: false },
            { name: 'Stan Van Samang', headline: true },
            { name: 'Lajos & The Gang', headline: false },
            { name: 'Monsieur', headline: false },
        ],
    },
];
